export const setAll = (state, all) => {
  state.all = all;
};

export const setOne = (state, one) => {
  state.one = one;
};


export const updateProgress = (state, progress) => {
  if (progress.loaded === progress.total) {
    state.progress = null;
  } else {
    state.progress = {
      loaded: progress.loaded,
      total: progress.total,
    };
  }
};
